import { render, staticRenderFns } from "./CallView.vue?vue&type=template&id=f3d0c54c&scoped=true"
import script from "./CallView.vue?vue&type=script&lang=js"
export * from "./CallView.vue?vue&type=script&lang=js"
import style0 from "./CallView.vue?vue&type=style&index=0&id=f3d0c54c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d0c54c",
  null
  
)

export default component.exports